export interface IFrontEndEvent {
  act: string;
  cat?: string;
  name: string;
  val?: string;
}

interface IFrontEndHandler {
  fn: (e: IFrontEndEvent) => void;
  pos: number;
}

export interface BaseEventManager {
  push(event: IFrontEndEvent): void;
}

export interface EventManager extends BaseEventManager {
  onEvent(fn: (event: IFrontEndEvent) => void): void;
}

export function getEventManager(): EventManager {
  const ME = window.ME || (window.ME = {});
  const events: EventManager | BaseEventManager = ME.Event || (ME.Event = []);
  if (Object.hasOwn(events, 'onEvent')) {
    return events as EventManager;
  }
  const eventList = events as unknown as IFrontEndEvent[];
  const handlers: IFrontEndHandler[] = [];

  function catchup(h: IFrontEndHandler) {
    for (; h.pos < eventList.length; h.pos++) {
      h.fn(eventList[h.pos]);
    }
  }
  function push(event: IFrontEndEvent) {
    eventList.push(event);
    handlers.forEach((h) => catchup(h));
  }

  function onEvent(fn: (e: IFrontEndEvent) => void) {
    const handler = {fn, pos: 0};
    handlers.push(handler);
    catchup(handler);
  }

  ME.Event = {onEvent, push};
  return ME.Event;
}
